<template>
  <div>
    <form @submit.prevent>
      <transition :name="transitionName" mode="out-in">
        <component
          :is="currentComponent"
          :key="currentStep"
          :form-data="formData"
          :errors="errors"
          :loading="loading"
          @update-form-data="updateFormData"
          @update-files="updateFiles"
          @validate-field="validateField"
          @remove-file="handleRemoveFile"
          @next-step="handleNextStep"
          @prev-step="handlePrevStep"
          @go-to-step3="handleGoToStep3"
          @activate-gift="handleActivateGift"
        ></component>
      </transition>
    </form>
  </div>
</template>

<script>
import FormStep1 from "./FormStep1.vue";
import FormStep2 from "./FormStep2.vue";
import FormStep3 from "./FormStep3.vue";
import FormStep4 from "./FormStep4.vue";
import { postValidateCode,postSubmit } from '@/api/portal';

export default {
  name: "SupportForm",
  components: {
    FormStep1,
    FormStep2,
    FormStep3,
    FormStep4,
  },
  data() {
    return {
      currentStep: 1,
      order_idSuccess:false,
      formData: {
        // Step 1
        name: "",
        email: "",
        order_id: "",
        comment: "",
        survey: "",
        files: [],
        // Step 2
        expectation: "yes",
        rating: 0,
        features: "",
        // Step 3
        gift: "",
      },
      errors: {},
      transitionName: "slide-left",
      loading: false
    };
  },
  computed: {
    currentComponent() {
      const stepMap = {
        1: "FormStep1",
        2: "FormStep2",
        3: "FormStep3",
        4: "FormStep4",
      };
      return stepMap[this.currentStep];
    },
  },
  methods: {
    updateFormData(newData) {
      console.log(newData, "newData");
      this.formData = { ...this.formData, ...newData };
      if (Object.prototype.hasOwnProperty.call(newData, "order_id")) {
        this.order_idSuccess = false;
      }
      // Clear the error for the field that was just updated
      const fieldName = Object.keys(newData)[0];
      if (this.errors[fieldName]) {
        const newErrors = { ...this.errors };
        delete newErrors[fieldName];
        this.errors = newErrors;
      }
    },
    updateFiles(files) {
      this.formData.files = files;
      if (this.errors.files) {
        const newErrors = { ...this.errors };
        delete newErrors.files;
        this.errors = newErrors;
      }
    },
    handleRemoveFile(fileId) {
      this.formData.files = this.formData.files.filter((f) => f.id !== fileId);
    },
    validateField(fieldName) {
        if (fieldName === 'name') {
            if (!this.formData.name.trim()) {
                this.$set(this.errors, 'name', this.$t('form.errors.nameRequired'));
            } else {
                this.$delete(this.errors, 'name');
            }
        } else if (fieldName === 'email') {
            if (!this.formData.email.trim()) {
                this.$set(this.errors, 'email', this.$t('form.errors.emailRequired'));
            } else if (!/^\S+@\S+\.\S+$/.test(this.formData.email)) {
                this.$set(this.errors, 'email', this.$t('form.errors.emailInvalid'));
            } else {
                this.$delete(this.errors, 'email');
            }
        }else if (fieldName === 'order_id') {
          this.order_idSuccess = false;
          if (!this.formData.order_id.trim()) {
            this.$set(this.errors, 'order_id',this.$t('form.errors.order_idRequired'))
          } else if (!/^\d{3}-\d{7}-\d{7}$/.test(this.formData.order_id)) {
            this.$set(this.errors, 'order_id',this.$t('form.errors.order_idInvalid'))
          } else {
            this.$delete(this.errors, 'order_id');
          }
            
        }
    },
    validateStep1() {
      const newErrors = {};
      if (!this.formData.name.trim())
        newErrors.name = this.$t("form.errors.nameRequired");

      if (!this.formData.email.trim()) {
        newErrors.email = this.$t("form.errors.emailRequired");
      } else if (!/^\S+@\S+\.\S+$/.test(this.formData.email)) {
        newErrors.email = this.$t("form.errors.emailInvalid");
      }

      if (!this.formData.order_id.trim()) {
        newErrors.order_id = this.$t("form.errors.order_idRequired");
      } else if (!/^\d{3}-\d{7}-\d{7}$/.test(this.formData.order_id)) {
        newErrors.order_id = this.$t("form.errors.order_idInvalid");
      }

      // if (!this.formData.comment.trim())
      //   newErrors.comment = this.$t("form.errors.commentRequired");

      // if (this.formData.files.length === 0)
      //   newErrors.files = this.$t("form.errors.filesRequired");

      // if (!this.formData.survey.trim())
      //   newErrors.survey = this.$t("form.errors.surveyRequired");

      this.errors = newErrors;
      return Object.keys(newErrors).length === 0;
    },
    validateOrderIdRemote() {
      return postValidateCode({ order_id: this.formData.order_id })
        .then(() => {
          this.order_idSuccess = true;
          this.$delete(this.errors, "order_id");
          return true;
        })
        .catch(() => {
          this.order_idSuccess = false;
          this.$set(
            this.errors,
            "order_id",
            this.$t("form.errors.order_IdValidateError")
          );
          return false;
        });
    },
    validateStep2() {
      const newErrors = {};
      if (!this.formData.expectation)
        newErrors.expectation = this.$t("form.errors.expectationRequired");
      if (this.formData.rating === 0)
        newErrors.rating = this.$t("form.errors.ratingRequired");
      if (this.formData.expectation !== "yes") {
        if (!this.formData.comment.trim())
          newErrors.comment = this.$t("form.errors.commentRequired");
      }
      this.errors = newErrors;
      return Object.keys(newErrors).length === 0;
    },
    validateStep3() {
      const newErrors = {};
      if (!this.formData.gift) {
        newErrors.gift = this.$t("form.errors.giftRequired");
      }
      this.errors = newErrors;
      return Object.keys(newErrors).length === 0;
    },
    async handleNextStep() {
      if (this.validateStep1()) {
        this.loading = true;
        const isOrderValid = await this.validateOrderIdRemote();
        if (!isOrderValid) {
          this.loading = false;
          return;
        }
        setTimeout(() => {
            this.transitionName = 'slide-left';
            this.currentStep = 2;
            this.errors = {};
            this.loading = false;
        }, 500);
      }
    },
    handlePrevStep() {
      this.transitionName = "slide-right";
      this.currentStep--;
      this.errors = {};
    },
    handleGoToStep3() {
      if (this.validateStep2()) {
        this.loading = true;
        setTimeout(() => {
            this.transitionName = 'slide-left';
            this.currentStep = 3;
            this.errors = {};
            this.loading = false;
        }, 500);
      }
    },
      /**
    * 将一个包含文件数组的复杂对象，处理并转换为标准的 FormData 格式。
    *
    * @param {object} sourceObject - 原始数据对象。
    * @param {string} fileArrayKey - 对象中包含文件数组的键名 (例如: 'attachments')。
    * @returns {FormData} - 处理后可直接用于网络请求的 FormData 对象。
    */
      processAndConvertToFormData(sourceObject, fileArrayKey = 'attachments') {
      const formData = new FormData();
      const fileMetadata = []; // 用于收集每个文件的元数据

      // 1. 遍历源对象的顶层键
      for (const key in sourceObject) {
        if (Object.prototype.hasOwnProperty.call(sourceObject, key)) {
          const value = sourceObject[key];

          // 2. 找到并特殊处理文件数组
          if (key === fileArrayKey && Array.isArray(value)) {
            // 遍历文件数组中的每个对象
            value.forEach((fileItem, index) => {
              // 确保这是一个包含文件对象的有效项
              if (fileItem && fileItem.file instanceof File) {
                // 直接追加文件本身。多次使用相同的键名，后端会自动解析为数组。
                // 我们使用 fileItem.name 作为文件名，确保一致性。
                formData.append(fileArrayKey, fileItem.file, fileItem.name);

                // 收集服务器需要知道的元数据，忽略客户端状态
                const metadataItem = {
                  id: fileItem.id, // 保留重要的ID
                  original_filename: fileItem.name // 保留原始文件名，便于后端匹配
                  // 如果还有其他需要传给服务器的业务字段，可以在这里添加
                  // e.g., description: fileItem.description
                };
                fileMetadata.push(metadataItem);
              }
            });
          } else {
            // 3. 对于所有其他非文件的普通数据，直接追加
            // 确保值不是对象（或为null），如果是，你可能需要JSON.stringify它
            if (typeof value !== 'object' || value === null) {
                formData.append(key, value);
            } else if (!Array.isArray(value)) {
                // 如果你还有其他嵌套的普通对象需要发送，可以stringify
                // formData.append(key, JSON.stringify(value));
            }
          }
        }
      }

      // 4. 将收集到的文件元数据数组转换为JSON字符串，并追加到FormData中
      if (fileMetadata.length > 0) {
        // 使用一个清晰的键名，比如 'attachments_metadata'
        formData.append(`${fileArrayKey}_metadata`, JSON.stringify(fileMetadata));
      }

      return formData;
    },
    handleActivateGift() {
      if (this.validateStep3()) {
        this.loading = true;
        let {name,email,order_id,comment,survey,files,expectation,rating,features,gift}=this.formData
        const obj = {
            user_name:name,
            user_email:email,
            order_id,
            comment,
            survey,
            attachments:files,
            expectation,
            rating,
            attraction:features,
            gift
        };
        
        const formData = this.processAndConvertToFormData(obj)
        postSubmit(formData).then(res => {
          this.transitionName = "slide-left";
          this.currentStep = 4;
          this.loading = false;
        }).catch(()=>{
          this.loading = false;
        })
        // console.log("Final Form Data:", {
        //   ...this.formData,
        //   files: this.formData.files.map((f) => f.name),
        // });
        // // Here you would typically send the data to a server
      }
    },
  },
};
</script>
<style scoped>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: all 0.3s ease-out;
}
.slide-left-enter,
.slide-right-leave-to {
  transform: translateX(30px);
  opacity: 0;
}
.slide-left-leave-to,
.slide-right-enter {
  transform: translateX(-30px);
  opacity: 0;
}
</style>
